module.exports = __webpack_public_path__ + "img/500.8600ef04.png";